import { makeVar, type ReactiveVar } from '@apollo/client';

import { COMFORTABLE, COMPACT, GRID } from 'src/constants';
import type { AkomiMediaCardGridState, AssetItem, DensityType, LayoutType } from 'src/types/store.types';

export const initialAkomiMediaCardGridState: AkomiMediaCardGridState = {
  layout: GRID as LayoutType,
  density: COMFORTABLE as DensityType,
  listViewDensity: COMPACT as DensityType,
  assetItems: [],
};

export const akomiMediaCardGridVar: ReactiveVar<AkomiMediaCardGridState> =
  makeVar<AkomiMediaCardGridState>(initialAkomiMediaCardGridState);

// Type-safe update helper
export const updateAkomiMediaCardGridVar = (update: Partial<AkomiMediaCardGridState>): AkomiMediaCardGridState => {
  const newState = {
    ...akomiMediaCardGridVar(),
    ...update,
  };
  akomiMediaCardGridVar(newState);
  return newState;
};

// Type exports for consumers
export type { AkomiMediaCardGridState, AssetItem, DensityType, LayoutType };
